<template>
    <path d="M10 12h-7l3 -3m0 6l-3 -3" />
    <path d="M14 12h7l-3 -3m0 6l3 -3" />
    <path d="M3 6v-3h18v3" />
    <path d="M3 18v3h18v-3" />
</template>


